import React, { useState, useEffect, useCallback } from "react";
import { Link, useLocation } from 'react-router-dom';
import axios from 'axios';
import Preloader from '../components/Preloader'

const AboutSection = () => {
  const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
  const location = useLocation();
  const isHomePage = location.pathname === '/';

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true)

  const fetchPagedata = useCallback(async () => {
    let apiUrl = '';
    if (location.pathname === '/') {
        apiUrl = apiBaseUrl+`page/2`;
    } else {
        apiUrl = apiBaseUrl+`page/10`;
    }    
    return axios.get(apiUrl).then((res) => {
      console.log(res.data);
      setData(res.data);
    });
  },[]);  

  useEffect(() => {
    fetchPagedata();
  }, [fetchPagedata]);

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth' // Optional, for smooth scrolling
        });
    };

  return (
    <>
    <section class="about-one">
        <div class="container">
            <div class="row">
                <div class="col-lg-6 wow fadeInLeft" data-wow-delay="100ms">
                    {isHomePage ? 
                    <div class="about-one__content">
                        <div class="sec-title text-left">
                            <h6 class="sec-title__tagline">About Us</h6>
                            <h3 class="sec-title__title">{ data?.title }</h3>
                        </div>
                        <p class="about-one__content__text" dangerouslySetInnerHTML={{ __html: data?.content }} />
                        <Link class="growim-btn" to="/about" onClick={scrollToTop}>
                            <span class="growim-btn__text">About Us</span>
                            <span class="growim-btn__icon"><i class="flaticon-up-right-arrow"></i></span>
                        </Link>
                    </div>
                    :
                    <div class="about-one__content">
                        <div class="sec-title text-left">
                            <h6 class="sec-title__tagline">{ data?.title }</h6>
                            <h3 class="sec-title__title">{ data?.meta?.sub_heading }</h3>
                        </div>
                        <p class="about-one__content__text" dangerouslySetInnerHTML={{ __html: data?.content }} />
                    </div> 
                    }
                </div>

                <div class="col-lg-6">
                    <div class="about-one__image wow fadeInRight" data-wow-delay="200ms">
                        <div class="about-one__image__bg" style={{ backgroundImage: 'url(assets/images/shapes/about-image-bg.png)' }}></div>
                        <img src={data?.featured_image} alt="about" />
                    </div>
                </div>
            </div>
        </div>
    </section>   
    </>    
  )
}

    export default AboutSection